import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Wordmark, Footer } from "@/components/Brand";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-wr-bg flex flex-col wr-grid-bg" data-testid="payment-cancel-page">
      <header className="border-b border-wr-border bg-black/70 backdrop-blur-xl">
        <div className="max-w-3xl mx-auto px-4 sm:px-8 h-16 flex items-center"><Wordmark size="md" /></div>
      </header>
      <main className="flex-1 flex items-center justify-center px-4 py-12">
        <div className="w-full max-w-lg bg-wr-surface border border-wr-border p-8">
          <XCircle className="h-10 w-10 text-wr-muted" />
          <h1 className="wr-heading font-bold text-white text-2xl mt-4">Checkout cancelled.</h1>
          <p className="text-sm text-wr-sub mt-2">No charge was made and no WarRoom was created. You can start again whenever you're ready.</p>
          <Button onClick={() => navigate("/")} data-testid="cancel-home" className="mt-6 rounded-none bg-wr-red hover:bg-wr-redHover text-white wr-mono uppercase tracking-wider h-11 px-6">Back to home</Button>
        </div>
      </main>
      <Footer />
    </div>
  );
}
